module.exports = __webpack_public_path__ + "img/ex-qr-search-inventory1.ed93fd15.svg";